// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27ni0","importantInfo":"styles_importantInfo__3VWgM"};